// extracted by mini-css-extract-plugin
export default {"containerArrow":"OrderTable_containerArrow__eZQdl","arrow":"OrderTable_arrow__e-WBG"};